export default function getResource(label, vars = []) {
    const resources = {
        removeAddressLabel: 'Supprimer l’adresse',
        remove: 'Retirer',
        editAddressLabel: 'Modifier l’adresse',
        edit: 'Modifier',
        addShippingAddress: 'Ajouter une nouvelle adresse',
        showMoreAddresses: 'Afficher tout',
        showLessAddresses: 'Afficher moins',
        deliveryMethod: 'Mode de livraison',
        setAsDefaultCheckbox: 'Définir comme l’adresse de livraison par défaut',
        editShipAddress: 'Modifier l’adresse d’expédition',
        addNewShipAddress: 'Ajouter une nouvelle adresse d’expédition',
        cancelButton: 'Annuler',
        continueButton: 'Continuer',
        maxShipAddressMessage: `Vous pouvez avoir jusqu’à ${vars[0]} adresses. Veuillez en supprimer une et en ajouter une autre à nouveau.`,
        areYouSureMessage: 'Êtes-vous sûr(e) de vouloir supprimer cette adresse?',
        removeAddress: 'Supprimer l’adresse',
        taxExemptAddressLabel: 'Adresse d’exemption de taxes',
        shippingMessage: 'Votre carte-cadeau sera expédiée à cette adresse.',
        useThisAddress: 'Utiliser cette adresse',
        enterAddressManually: 'Entrer l’adresse manuellement',
        maximumAddressesReached: 'Maximum atteint',
        deleteSavedAddresses: 'Veuillez supprimer l’une de vos adresses enregistrées avant d’en ajouter une nouvelle.',
        ok: 'OK',
        selectNewDefaultAddress: 'Sélectionnez une nouvelle adresse par défaut',
        selectNewDefaultAddressDone: 'Terminé',
        selectNewDefaultAddressLabel: 'Veuillez sélectionner l’adresse à définir en tant qu’adresse par défaut.',
        defaultAddressUpdated: 'Votre adresse par défaut est maintenant la suivante :',
        defaultAddressUpdatedDone: 'Compris',
        defaultAddressUpdatedTitle: 'Nouvelle adresse par défaut',
        fedexPickupLabel: 'Lieu de ramassage FedEx',
        pickupLabelCA: 'Lieu de ramassage Poste Canada'
    };

    return resources[label];
}
